/**
 * Sorting tabs — click proxy for Boost's sorting dropdown.
 *
 * The Boost `sorting.liquid` template renders the sorting options as a
 * horizontal tab strip instead of a dropdown: the trigger button is hidden and
 * the option list is always visible.
 *
 * Boost gates its own option-click handler on the dropdown's internal open
 * state, which is only entered by clicking the trigger. With the trigger hidden
 * that state never happens, so clicking a tab does nothing — Boost's handler
 * runs and bails out early.
 *
 * Verified in-browser: clicking an option directly leaves the URL untouched,
 * while clicking the (display:none) trigger first and then the option produces
 * `?sort=<value>` and re-sorts the grid. `.click()` fires on a display:none
 * element, so the trigger can stay hidden.
 *
 * This listens in the capture phase on `document`, so it survives Boost
 * re-rendering the toolbar after every sort — no MutationObserver needed.
 */
(function () {
  'use strict';

  var TAB_SELECTOR = '.boost-sd__sorting-option-item';
  var ROOT_SELECTOR = '.mx-sorting-tabs';
  var TRIGGER_SELECTOR = '.boost-sd__sorting-button';

  /**
   * Boost needs a moment to commit its open state before it will accept the
   * option click. 300ms was confirmed working by hand; 120ms is the shipped
   * compromise between reliability and feeling instant. Raise it if a tab click
   * ever fails to register.
   */
  var OPEN_DELAY = 120;

  // Set while we re-dispatch a click, so the replay passes through to Boost
  // instead of being intercepted again.
  var replaying = false;

  document.addEventListener(
    'click',
    function (event) {
      if (replaying) return;

      var target = event.target;
      if (!target || !target.closest) return;

      var item = target.closest(TAB_SELECTOR);
      if (!item) return;

      var root = item.closest(ROOT_SELECTOR);
      if (!root) return; // a normal Boost dropdown elsewhere — leave it alone

      var trigger = root.querySelector(TRIGGER_SELECTOR);
      if (!trigger) return;

      // Swallow the original click; Boost would ignore it anyway.
      event.preventDefault();
      event.stopPropagation();

      trigger.click(); // put Boost's dropdown into its open state

      setTimeout(function () {
        replaying = true;
        try {
          item.click();
        } finally {
          replaying = false;
        }
      }, OPEN_DELAY);
    },
    true
  );
})();
